import { createFileRoute } from "@tanstack/react-router"
import { AdminPage } from "@/components/pages/AdminPage"

// `/admin` — the users dashboard. Auth/admin guard is inherited from the parent
// admin layout's beforeLoad.
export const Route = createFileRoute(`/_authenticated/admin/`)({
  component: AdminPage,
  ssr: false,
})
